import { listenForMouseWheel } from './wheel';
import { listenForScrollBeyond, ScrollBeyondSettings } from './scroll-beyond';

declare const jQuery: any;
const $ = jQuery;

export function initMouseWheelScroll(): void {
    const $mainSlider = $(`.momentum-scroller > .slider`);
    if ($mainSlider.length === 0) {
        return;
    }

    const onTouch: boolean = 'ontouchstart' in window;

    if (onTouch) {
        return;
    }

    let sliderChangedRecently = false;
    let sliderChangedRecentlyTimer: any;

    const setSliderChangedRecentlyFalseTimed = () => {
        clearTimeout(sliderChangedRecentlyTimer);
        sliderChangedRecentlyTimer = setTimeout(() => {
            sliderChangedRecently = false;
        }, 500);
    };

    const triggerSliderChange = (type: 'prev' | 'next'): void => {
        if (!sliderChangedRecently) {
            sliderChangedRecently = true;
            setSliderChangedRecentlyFalseTimed();
            $mainSlider.trigger(`slide-to-${type}-item`);
        }
    };

    const sliderPrev = () => {
        triggerSliderChange('prev');
    };

    const sliderNext = () => {
        triggerSliderChange('next');
    };

    const mainOnWheel = (direction: 'up' | 'down'): void => {
        direction === 'up' ? sliderNext() : sliderPrev();
    };

    // very important that this is non-touch only:
    const { disable: disableWheel } = listenForMouseWheel(
        { onWheel: mainOnWheel, preventDefault: true },
        $mainSlider,
    );


    // prevent interference with overflowing/scrolling text containers
    $('.momentum-normal-content .body').each(function () {
        /* @ts-ignore */
        const self: HTMLElement = this;
        const child: HTMLElement | undefined = $(self).children().first()[0];
        if (!child) {
            return;
        }
        $(self).on('mouseenter', () => {
            const contentHeight = child.offsetHeight;
            const parentHeight = self.offsetHeight;
            disableWheel(!!contentHeight && !!parentHeight && contentHeight > parentHeight);
        }).on('mouseleave', () => {
            disableWheel(false);
        });
    });


    $mainSlider.find(`.momentum-gallery-tiles .scrolly`).each(function () {
        /* @ts-ignore */
        const scrolly: HTMLElement = this;
        const settings: ScrollBeyondSettings = {
            onScrollPastMin() {
                sliderPrev();
            },
            onScrollPastMax() {
                sliderNext();
            },
            type: 'wheel',
        };

        listenForScrollBeyond(settings, scrolly);

        $(scrolly).on('wheel', function (event: any) {
            event.stopPropagation();
            const dy: number = event.originalEvent.deltaY;
            scrolly.scrollLeft += dy;
        });
    });
}
